import { ReactElement } from 'react';
import { generatePath, Route, useParams } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

import { LiquidStakingTab } from './const';
import { Dashboard } from './screens/Dashboard';

export const STAKING_PATH = `/liquid-staking`;
export const STAKING_TAB_PATH = `${STAKING_PATH}/:tab`;

export const LiquidStakingRoutesConfig = createRouteConfig(
  {
    dashboard: {
      path: STAKING_TAB_PATH,
      generatePath: (tab: LiquidStakingTab = LiquidStakingTab.Stake) =>
        generatePath(STAKING_TAB_PATH, { tab }),
      useParams: (): { tab?: LiquidStakingTab } => {
        const data = useParams<{ tab: LiquidStakingTab }>();
        const { tab } = data;

        return { tab: tab || LiquidStakingTab.Stake };
      },
    },
  },
  STAKING_TAB_PATH,
);

export function getLiquidStakingRoutes(): ReactElement {
  return (
    <Route
      element={<Dashboard />}
      path={LiquidStakingRoutesConfig.dashboard.path}
    />
  );
}
